/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_ClubInputs */

const en_platform_team_club = /** @type {(inputs: Platform_Team_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const pl_platform_team_club = /** @type {(inputs: Platform_Team_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zespół`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Platform_Team_ClubInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_club = /** @type {((inputs?: Platform_Team_ClubInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_ClubInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_club(inputs)
	return en_platform_team_club(inputs)
});